import React, { Component } from 'react';
class PackItem extends Component {


  handleClick(e,packId) {
    try {
      e.preventDefault();
      this.props.packageClick(packId);
    } catch(ex){}
  }


  render() {
    let pack = this.props.Package;
    return (
      <div className="cb-wrap" onClick={(e) => this.handleClick(e,pack.PackageId)}>
        <div className="cb">
          <label htmlFor="" style={{cursor: "pointer"}}>
            <div className="package-check">
              {this.props.checked &&
              <i className="fas fa-check"></i>
              }
            </div>
            <strong>{pack.Name.replace("X","x")}</strong><br/><span style={{marginLeft: "25px"}}>{pack.Description}</span></label>
        </div>
        <div className="price" style={{margin: "0px", display: "flex", justifyContent: "center", alignItems: "center"}}>
          <p style={{margin: "0px"}}>
            {(this.props.payBy === "TOK" && !this.props.soldOut) && <a title="Tokens">{pack.Tokens}</a>}
            {(this.props.payBy === "EUR" && !this.props.soldOut) && <a title="Euros">{pack.Amount}&nbsp;<i className="fa fa-euro-sign"></i></a>}
            {this.props.soldOut && <a title="Soldout">Soldout</a>}
          </p>
        </div>
      </div>
    );
  }
}
export default PackItem;
